(function () {
  var fillings = [
    'Krokan',
    'Sütlü Çikolata',
    'Bitter Çikolata',
    'Beyaz Çikolata',
    'Draje Fıstık',
    'Frambuaz',
    'Yaban Mersini',
    'Çilek',
    'Muz',
    'Karışık Orman Meyvesi'
  ];

  function escapeHtml(value) {
    return value.replace(/[&<>\"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[character];
    });
  }

  function findAddToCartForm() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    return forms.find(function (form) {
      return form.querySelector('button[name="add"],button[type="submit"],input[type="submit"]');
    }) || forms[0];
  }

  function bindProperties(root) {
    var form = findAddToCartForm();
    if (!form) return false;
    form.setAttribute('id', 'bb-main-product-form');
    form.setAttribute('enctype', 'multipart/form-data');
    root.querySelectorAll('[data-bb-property]').forEach(function (input) {
      input.setAttribute('form', 'bb-main-product-form');
    });
    if (!form.dataset.bbCakePropertiesBound) {
      form.dataset.bbCakePropertiesBound = 'true';
      form.addEventListener('formdata', function (event) {
        root.querySelectorAll('[data-bb-property]').forEach(function (input) {
          if (!input.disabled && input.name && input.value) {
            event.formData.set(input.name, input.value);
          }
        });
      });
    }
    return true;
  }

  function hideLegacyFlavor(root) {
    var picker = root.querySelector('.bb-variant-picker--inside');
    if (!picker) return false;
    picker.querySelectorAll('.product-form__input,fieldset').forEach(function (group) {
      var heading = group.querySelector('legend,.form__label,label');
      var text = (heading ? heading.textContent : '').replace(/\s+/g, ' ').trim().toLocaleLowerCase('tr-TR');
      var isLegacyFlavor = text.indexOf('lezzet') === 0 || text.indexOf('pasta i\u00e7eri\u011fi') === 0;
      group.classList.toggle('bb-native-flavor-hidden', isLegacyFlavor);
    });
    var oldFlavor = root.querySelector('[data-bb-summary-flavor]');
    if (oldFlavor && oldFlavor.parentElement) oldFlavor.parentElement.hidden = true;
    return true;
  }

  function selectedNativeOption(root, labelText) {
    var picker = root.querySelector('.bb-variant-picker--inside');
    if (!picker) return '';
    var wanted = labelText.toLocaleLowerCase('tr-TR');
    var selected = '';
    picker.querySelectorAll('.product-form__input,fieldset').forEach(function (group) {
      if (selected) return;
      var heading = group.querySelector('legend,.form__label,label');
      var headingText = (heading ? heading.textContent : '').replace(/\s+/g, ' ').trim().toLocaleLowerCase('tr-TR');
      if (headingText.indexOf(wanted) !== 0) return;
      var select = group.querySelector('select');
      var checked = group.querySelector('input[type="radio"]:checked');
      if (select && select.options[select.selectedIndex]) selected = select.options[select.selectedIndex].text.trim();
      else if (checked) selected = String(checked.value || '').trim();
    });
    return selected;
  }

  function hasExternalMessageField() {
    return Boolean(document.querySelector(
      '.pplr-wrapper input[type="text"][name^="properties["],.pplr-wrapper textarea[name^="properties["],[data-bb-print-product-fields] input[name^="properties["],[data-bb-print-product-fields] textarea[name^="properties["]'
    ));
  }

  function syncGenericMessageField(root) {
    var message = root.querySelector('#bb-message');
    if (!message) return false;
    var field = message.closest('.bb-field');
    var summaryMessage = root.querySelector('[data-bb-summary-message]');
    var hideGeneric = hasExternalMessageField();
    message.disabled = hideGeneric;
    if (field) {
      field.hidden = hideGeneric;
      field.style.setProperty('display', hideGeneric ? 'none' : '', hideGeneric ? 'important' : '');
    }
    if (summaryMessage && summaryMessage.parentElement) {
      summaryMessage.parentElement.hidden = hideGeneric;
      summaryMessage.parentElement.style.setProperty('display', hideGeneric ? 'none' : '', hideGeneric ? 'important' : '');
    }
    root.classList.toggle('bb-product-helper--external-message', hideGeneric);
    return hideGeneric;
  }

  function selectedFillings(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-bb-filling]:checked')).map(function (input) {
      return input.value;
    });
  }

  function updateFillings(root) {
    var selected = selectedFillings(root);
    root.querySelectorAll('[data-bb-filling]').forEach(function (input) {
      input.disabled = selected.length >= 2 && !input.checked;
    });

    var first = root.querySelector('[data-bb-filling-one]');
    var second = root.querySelector('[data-bb-filling-two]');
    if (first) {
      first.value = selected[0] || '';
      first.disabled = !selected[0];
    }
    if (second) {
      second.value = selected[1] || '';
      second.disabled = !selected[1];
    }

    var count = root.querySelector('[data-bb-filling-count]');
    if (count) count.textContent = selected.length + '/2 seçildi';
    return selected;
  }

  function addSummaryRows(root) {
    var summary = root.querySelector('[data-bb-order-summary]');
    if (!summary || summary.querySelector('[data-bb-summary-cake]')) return;
    var messageRow = summary.querySelector('[data-bb-summary-message]');
    messageRow = messageRow && messageRow.parentElement;
    var rows = document.createElement('div');
    rows.innerHTML =
      '<div><span>Kek</span><strong data-bb-summary-cake>Seçilmedi</strong></div>' +
      '<div><span>Krema</span><strong data-bb-summary-cream>Seçilmedi</strong></div>' +
      '<div><span>İç malzemeler</span><strong data-bb-summary-fillings>Seçilmedi</strong></div>';
    Array.prototype.slice.call(rows.children).forEach(function (row) {
      summary.insertBefore(row, messageRow || null);
    });
  }

  function updateSummary(root) {
    var cake = root.querySelector('#bb-cake');
    var cream = root.querySelector('#bb-cream');
    var cakeSummary = root.querySelector('[data-bb-summary-cake]');
    var creamSummary = root.querySelector('[data-bb-summary-cream]');
    var fillingsSummary = root.querySelector('[data-bb-summary-fillings]');
    var servingsSummary = root.querySelector('[data-bb-summary-servings]');
    if (cakeSummary) cakeSummary.textContent = cake && cake.value ? cake.value : 'Seçilmedi';
    if (creamSummary) creamSummary.textContent = cream && cream.value ? cream.value : 'Seçilmedi';
    if (fillingsSummary) {
      var values = selectedFillings(root);
      fillingsSummary.textContent = values.length ? values.join(', ') : 'Seçilmedi';
    }
    if (servingsSummary) servingsSummary.textContent = selectedNativeOption(root, 'ki\u015fi say\u0131s\u0131') || '\u2014';
    syncGenericMessageField(root);
  }

  function injectFields(root) {
    var fields = root.querySelector('.bb-fields');
    if (!fields || fields.querySelector('#bb-cake')) return false;
    var fillingMarkup = fillings.map(function (filling) {
      return '<label class="bb-filling-option"><input type="checkbox" value="' + escapeHtml(filling) + '" data-bb-filling><span>' + escapeHtml(filling) + '</span></label>';
    }).join('');

    fields.insertAdjacentHTML('afterbegin',
      '<div class="bb-field">' +
        '<label for="bb-cake">Kek çeşidi</label>' +
        '<select id="bb-cake" class="bb-cake-select" data-bb-property name="properties[Kek çeşidi]" required>' +
          '<option value="">Seçiniz</option><option>Vanilyalı Kek</option><option>Kakaolu Kek</option>' +
        '</select>' +
      '</div>' +
      '<div class="bb-field">' +
        '<label for="bb-cream">Krema</label>' +
        '<select id="bb-cream" class="bb-cake-select" data-bb-property name="properties[Krema]" required>' +
          '<option value="">Seçiniz</option><option>Vanilyalı Krema</option><option>Çikolatalı Krema</option>' +
        '</select>' +
      '</div>' +
      '<fieldset class="bb-field bb-field--wide bb-fillings">' +
        '<legend>İç malzeme <small>En fazla 2 seçim</small></legend>' +
        '<div class="bb-filling-options">' + fillingMarkup + '</div>' +
        '<input type="hidden" data-bb-property data-bb-filling-one name="properties[İç Malzeme 1]" disabled>' +
        '<input type="hidden" data-bb-property data-bb-filling-two name="properties[İç Malzeme 2]" disabled>' +
        '<div class="bb-filling-count" data-bb-filling-count aria-live="polite">0/2 seçildi</div>' +
      '</fieldset>'
    );
    return true;
  }

  function enhanceDesignerMenu() {
    document.querySelectorAll('a[href*="/pages/kendi-pastani-tasarla"]').forEach(function (link) {
      if (!link.closest('header, .header, .shopify-section-group-header-group, #shopify-section-header')) return;
      link.classList.add('bb-designer-nav-link');
      try {
        var url = new URL(link.href, window.location.origin);
        url.searchParams.set('bb_guide', '1');
        link.href = url.pathname + url.search + url.hash;
      } catch (error) { /* Leave the original theme link untouched when URL parsing is unavailable. */ }
    });
  }

  function initialize() {
    enhanceDesignerMenu();
    var root = document.querySelector('[data-bb-product-helper]');
    if (!root) return;
    injectFields(root);
    addSummaryRows(root);
    hideLegacyFlavor(root);
    bindProperties(root);
    updateFillings(root);
    updateSummary(root);
    syncGenericMessageField(root);

    if (!root.dataset.bbCakeOptionsBound) {
      root.dataset.bbCakeOptionsBound = 'true';
      root.addEventListener('change', function (event) {
        if (event.target.matches('[data-bb-filling]')) updateFillings(root);
        updateSummary(root);
      });
      root.addEventListener('input', function () { updateSummary(root); });
    }

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      bindProperties(root);
      hideLegacyFlavor(root);
      syncGenericMessageField(root);
      updateSummary(root);
      if (attempts >= 40) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
